var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "rb-board-with-fields-aside" }, [
    _c(
      "div",
      { staticClass: "rb-board-with-fields-aside__title" },
      [_vm._t("title")],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "rb-board-with-fields-aside__banners" },
      [
        _c(
          "rb-smart-container",
          {
            attrs: {
              "columns-of-next-slide": 0,
              "slides-per-view-tablet": 1,
              navigation: false,
              "full-screen-mobile": true,
            },
          },
          [_vm._t("banners")],
          2
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "rb-board-with-fields-aside__cta" },
      [_vm._t("cta_block")],
      2
    ),
    _vm._v(" "),
    _vm.$slots.note
      ? _c(
          "div",
          { staticClass: "rb-board-with-fields-aside__note" },
          [_vm._t("note")],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }